import * as React from 'react';

type IndeterminateCheckboxProps = {
    disabled: boolean;
    indeterminate: boolean;
    checked: boolean;
    onChange: (...args: any) => any;
    onClick: (...args: any) => any;
    style: {
        cursor: 'pointer';
    };
    title: string;
};

// Scooped from react-table's example
const IndeterminateCheckbox = React.forwardRef<IndeterminateCheckboxProps, HTMLInputElement>(
    // @ts-expect-error
    (props: IndeterminateCheckboxProps, ref) => {
        const {indeterminate, ...rest} = props;
        const defaultRef = React.useRef<HTMLInputElement | null | undefined>();
        const resolvedRef = ref || defaultRef;

        React.useEffect(() => {
            // @ts-expect-error
            if (resolvedRef && resolvedRef.current) {
                // @ts-expect-error
                resolvedRef.current.indeterminate = indeterminate;
            }
        }, [resolvedRef, indeterminate]);

        // @ts-expect-error
        return <input type='checkbox' ref={resolvedRef} {...rest} />;
    }
);

type Props = {
    getToggleRowSelectedProps: (props: any) => {
        checked: boolean;
        indeterminate: boolean;
        onChange: (...args: any) => any;
        style: {
            cursor: 'pointer';
        };
        title: string;
    };
    disabled?: boolean;
};

export function TableRowCheckbox(props: Props) {
    return (
        <IndeterminateCheckbox
            // @ts-expect-error
            {...props.getToggleRowSelectedProps()}
            // @ts-expect-error
            disabled={props.disabled}
            // @ts-expect-error
            onClick={(e) => {
                e.stopPropagation();
            }}
        />
    );
}
